import React, { lazy, useMemo, useState } from 'react'
import { Route, Switch } from 'react-router'
import { ChainId } from '@nominex/nomiswap-sdk'
import { useMatchBreakpoints } from '@nominex/dex-uikit'

import { useWagmi } from 'libs/wagmi'

import Footer from './components/App/Footer'
import SuspenseWithChunkError from './components/SuspenseWithChunkError'
import PageLoader from './components/Loader/PageLoader'

// Views included in the main bundle because they are the most visited pages
// import Home from './views/Home'
import Swap from './views/Swap'
import { RedirectDuplicateTokenIds, RedirectOldAddLiquidityPathStructure } from './views/AddLiquidity/redirects'
import RedirectOldRemoveLiquidityPathStructure from './views/RemoveLiquidity/redirects'
import { RedirectToSwap } from './views/Swap/redirects'
import Menu from './components/Menu'
import Aside from './components/ProSidebar'
import { COLLAPSED_WIDTH, WIDTH } from './components/ProSidebar/config/config'
import PromoHeader from './components/PromoHeader'

// Route-based code splitting

const FarmsView = lazy(() => import('./views/Farms/FarmsView'))
const FarmView = lazy(() => import('./views/Farms/FarmView'))
// const CreateFarmView = lazy(() => import('./views/Farms/CreateFarmView'))
const AddLiquidity = lazy(() => import('./views/AddLiquidity'))
const Liquidity = lazy(() => import('./views/Pool'))
const PoolFinder = lazy(() => import('./views/PoolFinder'))
const RemoveLiquidity = lazy(() => import('./views/RemoveLiquidity'))
// const Referrals = lazy(() => import('./views/Referrals'))
const Bonuses = lazy(() => import('./views/Bonuses'))
// const Info = lazy(() => import('./views/Info'))
// const Dashboard = lazy(() => import('./views/Dashboard'))
const Pools = lazy(() => import('./views/Pools'))
const OraclePools = lazy(() => import('./views/OraclePools'))
const NotFound = lazy(() => import('./views/NotFound'))
const NetworkNotSupported = lazy(() => import('./views/NetworkNotSupported'))
const Support = lazy(() => import('./views/Support'))

const Layout: React.FC = () => {
  const { chain, chainId } = useWagmi()
  const { isMobile, isTablet } = useMatchBreakpoints()
  const [collapsed, setCollapsed] = useState(isTablet)
  const [toggled, setToggled] = useState(false)

  const switchCollapsedState = () => {
    setCollapsed(!collapsed)
  }

  const switchToggledState = () => {
    setToggled(!toggled)
  }

  const closeSidebar = () => {
    setToggled(false)
  }

  const wrapperWidth = useMemo(() => {
    if (isMobile) {
      return '100%'
    }
    if (collapsed) {
      return `calc(100% - ${COLLAPSED_WIDTH + 1}px)`
    }
    return `calc(100% - ${WIDTH + 1}px)`
  }, [collapsed, isMobile])

  const farmsUnavailable = [ChainId.ARBITRUM, ChainId.AVALANCHE, ChainId.GNOSIS, ChainId.OPTIMISM].includes(chainId)

  return (
    <div className="flex flex-col">
      <PromoHeader />
      <div className="flex">
        <Aside
          collapsed={collapsed}
          toggled={toggled}
          switchCollapsedState={switchCollapsedState}
          switchToggledState={switchToggledState}
          closeSidebar={closeSidebar}
        />
        <Menu width={wrapperWidth} handleToggleSidebar={switchToggledState}>
          <SuspenseWithChunkError fallback={<PageLoader />}>
            <Switch>
              <Route exact path="/" component={Liquidity} />
              <Route exact path="/farms">
                {farmsUnavailable ? <Route component={NetworkNotSupported} /> : <FarmsView />}
              </Route>
              <Route exact path="/farms/community/:stakingServiceAddress">
                {chainId === ChainId.BSC ? <FarmView /> : <Route component={NetworkNotSupported} />}
              </Route>
              {/* <Route exact path="/farms/create">
                {!chain?.unsupported && chainId === ChainId.BSC ? (
                  <CreateFarmView />
                ) : (
                  <Route component={NetworkNotSupported} />
                )}
              </Route> */}
              <Route path="/pools">
                {chainId === ChainId.BSC ? <Pools /> : <Route component={NetworkNotSupported} />}
              </Route>
              {/* <Route path="/referrals">
                {!chain?.unsupported && chainId === ChainId.BSC ? (
                  <Referrals />
                ) : (
                  <Route component={NetworkNotSupported} />
                )}
              </Route> */}
              <Route path="/bonuses">
                {chainId === ChainId.BSC ? <Bonuses /> : <Route component={NetworkNotSupported} />}
              </Route>
              {/* <Route path="/info">
                {!chain?.unsupported && chainId === ChainId.BSC ? <Info /> : <Route component={NetworkNotSupported} />}
              </Route> */}
              {/* <Route path="/dashboard">
                {!chain?.unsupported && chainId === ChainId.BSC ? (
                  <Dashboard />
                ) : (
                  <Route component={NetworkNotSupported} />
                )}
              </Route> */}
              {/* Using this format because these components use routes injected props. We need to rework them with hooks */}
              <Route exact strict path="/swap" component={Swap} />
              <Route exact strict path="/swap/:outputCurrency" component={RedirectToSwap} />
              <Route exact strict path="/liquidity" component={Liquidity} />
              <Route exact path="/liquidity/find" component={PoolFinder} />
              <Route exact path="/liquidity/add" component={AddLiquidity} />
              <Route exact path="/liquidity/add/:currencyIdA" component={RedirectOldAddLiquidityPathStructure} />
              <Route exact path="/liquidity/add/:currencyIdA/:currencyIdB" component={RedirectDuplicateTokenIds} />
              <Route
                exact
                strict
                path="/liquidity/remove/:tokens"
                component={RedirectOldRemoveLiquidityPathStructure}
              />
              <Route exact strict path="/liquidity/remove/:currencyIdA/:currencyIdB" component={RemoveLiquidity} />
              <Route exact strict path="/o-pools" component={OraclePools} />
              <Route exact strict path="/support" component={Support} />
              {/* 404 */}
              <Route component={NotFound} />
            </Switch>
          </SuspenseWithChunkError>
          <Footer />
        </Menu>
      </div>
    </div>
  )
}

export default Layout
